// ConfirmNoChangeModal.jsx
import React from "react";

export default function ConfirmNoChangeModal({
  open,
  onClose,
  onConfirm,
  stationName,
  stationId,
  items = [],
}) {
  if (!open) return null;

  return (
    <div className="confirmModal__backdrop" onMouseDown={onClose}>
      <div
        className="confirmModal__card confirmModal__card--nochange"
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="confirmModal__header">
          <div className="confirmModal__badge confirmModal__badge--nochange">
            Bez změn
          </div>

          <h3 className="confirmModal__title">Potvrdit kontrolu cen</h3>
          <p className="confirmModal__subtitle">
            Neposíláš žádné změny. Jen potvrzuješ, že jsi ceny zkontroloval a
            necháváš je beze změny.
          </p>
        </div>

        <div className="confirmModal__body">
          <div className="confirmModal__summaryBox">
            <div className="confirmModal__row">
              <span className="confirmModal__label">Stanice</span>
              <span className="confirmModal__value">{stationName || "—"}</span>
            </div>
            <div className="confirmModal__row">
              <span className="confirmModal__label">Změny</span>
              <span className="confirmModal__value">
                <strong>0</strong>
              </span>
            </div>

            {/* pokud chceš: interní info */}
            {stationId ? (
              <div className="confirmModal__hint">ID stanice: {stationId}</div>
            ) : null}
          </div>
          {items.length > 0 ? (
  <div className="confirmModal__list">
    <div className="confirmModal__listTitle">
      Ceny mimo limit (okolní ČS)
      <span className="confirmModal__listCount">{items.length}</span>
    </div>

    <div className="confirmModal__table">
      <div className="confirmModal__thead">
        <span>Stanice</span>
        <span>Produkt</span>
        <span>Měna</span>
        <span>Hodnota</span>
        <span>Δ vs Armex</span>
        <span>Limit</span>
      </div>

      {items.slice(0, 20).map((it, idx) => (
        <div key={idx} className="confirmModal__tr">
          <span title={it.stationName}>{it.stationName}</span>
          <span>{it.fuel}</span>
          <span>{it.currency}</span>
          <span>{it.value}</span>
          <span className={`confirmModal__delta ${it.side === "nad" ? "is-high" : "is-low"}`}>
            {it.diff > 0 ? `+${it.diff.toFixed(2)}` : it.diff.toFixed(2)}
          </span>
          <span className="confirmModal__limit">
            {it.limitMin} .. {it.limitMax}
          </span>
        </div>
      ))}

      {items.length > 20 ? (
        <div className="confirmModal__more">
          Zobrazeno prvních 20 položek (celkem {items.length}).
        </div>
      ) : null}
    </div>
  </div>
) : (
  <div className="confirmModal__okInfo">
    V tuto chvíli nejsou u okolních ČS žádné ceny mimo limit.
  </div>
)}


          <div className="confirmModal__warning nochange">
            Potvrzením se uloží pouze informace o kontrole (bez úprav cen).
          </div>
        </div>

        <div className="confirmModal__footer">
          <button className="confirmModal__btn" type="button" onClick={onClose}>
            Zpět
          </button>

          <button
            className="confirmModal__btn confirmModal__btn--grey"
            type="button"
            onClick={onConfirm}
          >
            Potvrdit beze změn
          </button>
        </div>
      </div>
    </div>
  );
}
